import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import PageHeader from "../../../components/PageHeader";
import { AntrepoInService } from "../../../services/AntrepoInService";
import { AddAntrepoInResponse } from "../../../models/response/antrepoIn/AddAntrepoInResponse";
import { GetAntrepoInByIdResponse, GetAntrepoInByIdResponseAntrepoInLock, GetAntrepoInByIdResponseAntrepoInMessage, GetAntrepoInByIdResponseAntrepoInVehicle, GetAntrepoInByIdResponseAntrepoInVehicleProduct, GetAntrepoInByIdResponseAntrepoInVehicleService, GetAntrepoInByIdResponseData, GetAntrepoInByIdResponseFileArchive } from "../../../models/response/antrepoIn/GetAntrepoInByIdResponse";
import GeneralInformation from "./Components/GeneralInformation";
import { ConstantService } from "../../../services/ConstantService";
import { AntrepoExitTypeEnum, GuaranteeTypeEnum, ProductTypeEnum } from "../../../models/common/Enums";
import { GetConstantListResponse } from "../../../models/response/constant/GetConstantListResponse";
import FirmInformation from "./Components/FirmInformation";
import VehicleInformation from "./Components/VehicleInformation";
import ProductInformation from "./Components/ProductInformation";
import ServicesInformation from "./Components/ServicesInformation";
import FileArchives from "./Components/FileArchives";
import { WelcomeService } from "../../../services/WelcomeService";
import { GetWelcomeListResponseData } from "../../../models/response/welcome/GetWelcomeListResponse";
import { GetWelcomeByIdResponse } from "../../../models/response/welcome/GetWelcomeByIdResponse";
import { AddWelcomeResponse } from "../../../models/response/welcome/AddWelcomeResponse";
import moment from "moment";
import { AntrepoOutService } from "../../../services/AntrepoOutService";
import { GetAntrepoOutListByAntrepoInIdResponse, GetAntrepoOutListByAntrepoInIdResponseData } from "../../../models/response/antrepoOut/GetAntrepoOutListByAntrepoInIdResponse";
import AntrepoOuts from "./Components/AntrepoOuts";
import { GetAntrepoListResponse } from "../../../models/response/antrepo/GetAntrepoListResponse";
import { AntrepoService } from "../../../services/AntrepoService";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import CustomTextInput from "../../../components/CustomTextInput";
import TransferInformation from "./Components/TransferInformation";
import { GetAntrepoOutByIdResponse, GetAntrepoOutByIdResponseData } from "../../../models/response/antrepoOut/GetAntrepoOutByIdResponse";
import TransferAntrepoOuts from "./Components/TransferAntrepoOuts";
import MessageHistory from "./Components/MessageHistory";
import RedreseAntrepoIn from "./Components/RedreseAntrepoIn";
import { GetConstantByIdResponse } from "../../../models/response/constant/GetConstantByIdResponse";

const AntrepoInAdd = () => {
    const auth = useSelector((state: RootState) => state.auth)
    const navigate = useNavigate();
    const pageName = "Antrepo Modülü > Antrepo Girişi"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();
    const generalInformationRef: any = useRef();
    // const dateInformationRef: any = useRef();
    const firmInformationRef: any = useRef();
    const transferInformationRef: any = useRef();
    const vehicleInformationRef: any = useRef();
    const productInformationRef: any = useRef();
    const serviceInformationRef: any = useRef();
    const fileArchivesRef: any = useRef();
    const antrepoOutsRef: any = useRef();
    const antrepoInMessagesRef: any = useRef();
    const transferAntrepoOutsRef: any = useRef();
    const redreseAntrepoInRef: any = useRef();

    const [antrepoInId, setAntrepoInId] = useState<string | undefined>(undefined);

    const [ledgerNo, setLedgerNo] = useState<string | undefined>(undefined);
    const [freeStorageRefNo, setFreeStorageRefNo] = useState<string | undefined>(undefined);
    const [antrepoDeclarationNo, setAntrepoDeclarationNo] = useState<string | undefined>(undefined);
    const [antrepoDeclarationDate, setAntrepoDeclarationDate] = useState<string | undefined>(undefined);
    const [goodsAmount, setGoodsAmount] = useState<string | undefined>(undefined);
    const [selectedGoodsAmountCurrencyType, setSelectedGoodsAmountCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [guaranteeAmount, setGuaranteeAmount] = useState<string | undefined>(undefined);
    const [selectedGuaranteeAmountCurrencyType, setSelectedGuaranteeAmountCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedSaleType, setSelectedSaleType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedAntrepo, setSelectedAntrepo] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedGuaranteeType, setSelectedGuaranteeType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [declarationPotQuantity, setDeclarationPotQuantity] = useState<string | undefined>(undefined);
    const [declarationPotWeight, setDeclarationPotWeight] = useState<string | undefined>(undefined);

    const [storageEnteranceDate, setStorageEnteranceDate] = useState<string | undefined>(undefined);

    const [selectedSenderFirm, setSelectedSenderFirm] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedReceiverFirm, setSelectedReceiverFirm] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedDutyFirm, setSelectedDutyFirm] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCustomsDirectorate, setSelectedCustomsDirectorate] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedExitCountry, setSelectedExitCountry] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedRepresentative, setSelectedRepresentative] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [selectedTransferFirm, setSelectedTransferFirm] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [transferAntrepoDeclarationNo, setTransferAntrepoDeclarationNo] = useState<string | undefined>(undefined);
    const [transferAntrepoDeclarationDate, setTransferAntrepoDeclarationDate] = useState<string | undefined>(undefined);
    const [transferInvoiceFile, setTransferInvoiceFile] = useState<File | undefined>(undefined);
    const [transferInvoice, setTransferInvoice] = useState<string | undefined>(undefined);

    const [antrepoInVehicles, setAntrepoInVehicles] = useState<GetAntrepoInByIdResponseAntrepoInVehicle[]>([]);
    const [antrepoInVehicleProducts, setAntrepoInVehicleProducts] = useState<GetAntrepoInByIdResponseAntrepoInVehicleProduct[]>([]);
    const [antrepoInVehicleServices, setAntrepoInVehicleServices] = useState<GetAntrepoInByIdResponseAntrepoInVehicleService[]>([]);
    const [antrepoInLocks, setAntrepoInLocks] = useState<GetAntrepoInByIdResponseAntrepoInLock[]>([]);
    const [antrepoInMessages, setAntrepoInMessages] = useState<GetAntrepoInByIdResponseAntrepoInMessage[]>([]);

    const [selectedProductType, setSelectedProductType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [defaultProductType, setDefaultProductType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [fileArchives, setFileArchives] = useState<GetAntrepoInByIdResponseFileArchive[]>([]);
    const [antrepoOfferId, setAntrepoOfferId] = useState<string | undefined>(undefined);
    const [welcomeList, setWelcomeList] = useState<GetWelcomeListResponseData[]>([]);
    const [defaultAntrepoDeclarationNo, setDefaultAntrepoDeclarationNo] = useState('');
    const [antrepoOuts, setAntrepoOuts] = useState<GetAntrepoOutListByAntrepoInIdResponseData[]>([]);
    const [selectedLockReason, setSelectedLockReason] = useState<CustomSingleSelectModel | undefined>(undefined);

    const [isLocked, setIsLocked] = useState(false);
    const [isDisabledFromLock, setIsDisabledFromLock] = useState(false);

    const [defaultLockReason, setDefaultLockReason] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [unlockReason, setUnlockReason] = useState<string | undefined>('');

    const [isClosed, setIsClosed] = useState(false);

    const [transferAntrepoOutId, setTransferAntrepoOutId] = useState<string | undefined>(undefined);
    const [transferAntrepoOut, setTransferAntrepoOut] = useState<GetAntrepoOutByIdResponseData | undefined>(undefined);

    const [isRedrese, setIsRedrese] = useState(false);

    const [redreseAntrepoInId, setRedreseAntrepoInId] = useState<string | undefined>(undefined);

    const [redreseAntrepoIn, setRedreseAntrepoIn] = useState<GetAntrepoInByIdResponseData | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        var isRedrese = searchParams.get("isRedrese");
        getData(id, undefined, isRedrese);
    }, [])

    const getData = async (_id: string | undefined | null = undefined, _lastSelectedOne: string | undefined = undefined, _isRedrese: string | undefined | null) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;
            var isRedrese = !(!(_isRedrese));

            setIsRedrese(isRedrese);

            var response5: GetConstantListResponse = await ConstantService.getConstantList('PRODUCT_TYPE', undefined, ProductTypeEnum.NORMAL);

            if (!response5.isSuccess) {
                toast.error(response5.message)
                return;
            }

            if (response5.data.length > 0) {
                setDefaultProductType({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
                setSelectedProductType({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 })
            }

            var response5: GetConstantListResponse = await ConstantService.getConstantList('ANTREPO_IN_LOCK_REASON', undefined, "1");

            if (!response5.isSuccess) {
                toast.error(response5.message)
                return;
            }

            if (response5.data.length > 0) {
                setDefaultLockReason({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
            }

            if (!id) {
                var response5: GetConstantListResponse = await ConstantService.getConstantList('GUARANTEE_TYPE', undefined, GuaranteeTypeEnum.GTRANT_1);

                if (!response5.isSuccess) {
                    toast.error(response5.message)
                    return;
                }

                if (response5.data.length > 0) {
                    setSelectedGuaranteeType({ label: response5.data[0].value + '', value: response5.data[0].constantId, additionalValue1: response5.data[0].additionalValue1 });
                }

                var response6: GetAntrepoListResponse = await AntrepoService.getAntrepoList()

                if (!response6.isSuccess) {
                    toast.error(response6.message)
                    return;
                }

                if (response6.data.length == 1) {
                    setSelectedAntrepo({ label: response6.data[0].baseAntrepoFullName, value: response6.data[0].antrepoId });

                    if (!Helpers.isEmpty(response6.data[0].baseAntrepoId)) {
                        var response7: GetConstantByIdResponse = await ConstantService.getConstantById(response6.data[0].baseAntrepoId);

                        if (!response7.isSuccess) {
                            toast.error(response6.message)
                            return;
                        }

                        if (response7.data && response7.data.parentConstantId) {
                            response7 = await ConstantService.getConstantById(response7.data.parentConstantId);

                            if (!response7.isSuccess) {
                                toast.error(response6.message)
                                return;
                            }

                            if (response7.data) {
                                setSelectedCustomsDirectorate({ label: response7.data.value, value: response7.data.constantId });
                                generateDeclarationNo({ label: response7.data.value, value: response7.data.constantId, additionalValue1: response7.data.additionalValue1 })
                            }
                        }
                    }
                }
            }

            if (id) {
                var response2: GetAntrepoOutListByAntrepoInIdResponse = await AntrepoOutService.getAntrepoOutListByAntrepoInId(id);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                setAntrepoOuts(response2.data);

                var response: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                if (!isRedrese && response.data.redreseAntrepoInId) {
                    var response4: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(response.data.redreseAntrepoInId);

                    if (!response4.isSuccess) {
                        toast.error(response4.message)
                        return;
                    }

                    setRedreseAntrepoIn(response4.data);
                }

                setRedreseAntrepoInId(isRedrese ? id : response.data.redreseAntrepoInId);
                setAntrepoInId(isRedrese ? undefined : response.data.antrepoInId);
                setTransferAntrepoOutId(response.data.transferAntrepoOutId);
                setLedgerNo(isRedrese ? undefined : response.data.ledgerNo);
                setDeclarationPotQuantity(response.data.declarationPotQuantity);
                setDeclarationPotWeight(response.data.declarationPotWeight);
                setFreeStorageRefNo(response.data.freeStorageRefNo);
                setIsLocked(response.data.isLocked);

                if (response.data.transferAntrepoOutId) {
                    var response3: GetAntrepoOutByIdResponse = await AntrepoOutService.getAntrepoOutById(response.data.transferAntrepoOutId);

                    if (!response3.isSuccess) {
                        toast.error(response3.message)
                        return;
                    }

                    setTransferAntrepoOut(response3.data);
                }

                // Devir çıkış olursa alanlar kilitlensin
                // if (response2.data.find(x => x.exitTypeKey == AntrepoExitTypeEnum.DEVIR_CIKIS))
                if (response.data.isClosed || response.data.isRedrese)
                    setIsDisabledFromLock(true)
                else
                    setIsDisabledFromLock(response.data.isLocked);

                if (response.data.lockReasonId && response.data.lockReasonName)
                    setSelectedLockReason({ label: response.data.lockReasonName, value: response.data.lockReasonId });
                else
                    setSelectedLockReason(undefined);

                if (response.data.saleTypeId && response.data.saleTypeName)
                    setSelectedSaleType({ label: response.data.saleTypeName, value: response.data.saleTypeId });

                if (response.data.antrepoId && response.data.antrepoName)
                    setSelectedAntrepo({ label: response.data.antrepoName, value: response.data.antrepoId });
                else {
                    var response6: GetAntrepoListResponse = await AntrepoService.getAntrepoList()

                    if (!response6.isSuccess) {
                        toast.error(response6.message)
                        return;
                    }

                    if (response6.data.length == 1) {
                        setSelectedAntrepo({ label: response6.data[0].baseAntrepoFullName, value: response6.data[0].antrepoId });
                    }
                }

                setAntrepoDeclarationNo(isRedrese ? undefined : response.data.antrepoDeclarationNo);

                setGoodsAmount(response.data.goodsAmount?.toString());

                if (response.data.goodsAmountCurrencyTypeId && response.data.goodsAmountCurrencyTypeName)
                    setSelectedGoodsAmountCurrencyType({ label: response.data.goodsAmountCurrencyTypeName, value: response.data.goodsAmountCurrencyTypeId });

                if (response.data.guaranteeTypeId && response.data.guaranteeTypeName)
                    setSelectedGuaranteeType({ label: response.data.guaranteeTypeName, value: response.data.guaranteeTypeId });

                setAntrepoDeclarationDate(isRedrese ? undefined : response.data.antrepoDeclarationDate);

                setGuaranteeAmount(response.data.guaranteeAmount?.toString());

                if (response.data.guaranteeAmountCurrencyTypeId && response.data.guaranteeAmountCurrencyTypeName)
                    setSelectedGuaranteeAmountCurrencyType({ label: response.data.guaranteeAmountCurrencyTypeName, value: response.data.guaranteeAmountCurrencyTypeId });

                setStorageEnteranceDate(response.data.storageEnteranceDate);

                if (response.data.senderFirmId && response.data.senderFirmName)
                    setSelectedSenderFirm({ label: response.data.senderFirmName, value: response.data.senderFirmId });

                if (response.data.receiverFirmId && response.data.receiverFirmName)
                    setSelectedReceiverFirm({ label: response.data.receiverFirmName, value: response.data.receiverFirmId });

                if (response.data.dutyFirmId && response.data.dutyFirmName)
                    setSelectedDutyFirm({ label: response.data.dutyFirmName, value: response.data.dutyFirmId });

                if (response.data.customsDirectorateId && response.data.customsDirectorateName) {
                    setSelectedCustomsDirectorate({ label: response.data.customsDirectorateName, value: response.data.customsDirectorateId, additionalValue1: response.data.customsDirectorateKey });
                    setDefaultAntrepoDeclarationNo(new Date().getFullYear().toString().substring(2) + response.data.customsDirectorateKey + 'AN');

                    if (isRedrese)
                        setAntrepoDeclarationNo(new Date().getFullYear().toString().substring(2) + response.data.customsDirectorateKey + 'AN');
                }

                if (response.data.exitCountryId && response.data.exitCountryName)
                    setSelectedExitCountry({ label: response.data.exitCountryName, value: response.data.exitCountryId });

                if (response.data.representativeId && response.data.representativeName)
                    setSelectedRepresentative({ label: response.data.representativeName, value: response.data.representativeId });

                if (response.data.transferFirmId && response.data.transferFirmName)
                    setSelectedTransferFirm({ label: response.data.transferFirmName, value: response.data.transferFirmId });

                setTransferAntrepoDeclarationNo(response.data.transferAntrepoDeclarationNo);
                setTransferAntrepoDeclarationDate(response.data.transferAntrepoDeclarationDate);
                setTransferInvoice(response.data.transferInvoice)
                setAntrepoInVehicles(response.data.antrepoInVehicles.map(function (x) {
                    if (_lastSelectedOne && x.groupNo == _lastSelectedOne)
                        x.isSelected = true;

                    return { ...x, antrepoInVehicleId: isRedrese ? Helpers.generateUUID(true) : x.antrepoInVehicleId };
                }));
                setAntrepoInVehicleProducts(response.data.antrepoInVehicleProducts.map(function (x) {
                    return { ...x, antrepoInVehicleProductId: isRedrese ? Helpers.generateUUID(true) : x.antrepoInVehicleProductId };
                }));
                setAntrepoInVehicleServices(response.data.antrepoInVehicleServices.map(function (x) {
                    return { ...x, antrepoInVehicleServiceId: isRedrese ? Helpers.generateUUID(true) : x.antrepoInVehicleServiceId };
                }));
                setAntrepoInLocks(response.data.antrepoInLocks)
                setAntrepoInMessages(response.data.antrepoInMessages);
                setFileArchives(response.data.fileArchives);
                setAntrepoOfferId(response.data.antrepoOfferId);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const lockRecord = () => {
        if (!selectedLockReason) {
            toast.error('Kilit Nedeni Seçiniz!')
            return;
        }

        saveAntrepoIn(undefined, undefined, true, true)
    }

    const unlockRecord = () => {
        if (Helpers.isEmpty(unlockReason)) {
            toast.error('Kilit Açma Açıklaması Giriniz!')
            return;
        }

        saveAntrepoIn(undefined, undefined, true, false)
    }

    const saveAntrepoIn = async (_antrepoInVehicles: GetAntrepoInByIdResponseAntrepoInVehicle[] | undefined = undefined, isFromWelcome: boolean = false, isLastStep: boolean = false, _isLocked: boolean | undefined = undefined) => {
        try {
            if (Helpers.isEmpty(antrepoDeclarationNo)) {
                toast.error('Antrepo Beyan No alanını doldurunuz!')
                return false;
            }
            else if (!selectedAntrepo) {
                toast.error('Antrepo alanını doldurunuz!')
                return false;
            }
            else if (Helpers.isEmpty(goodsAmount) || !selectedGoodsAmountCurrencyType) {
                toast.error('Mal Değeri alanını doldurunuz!')
                return false;
            }
            else if (Helpers.isEmpty(guaranteeAmount) || !selectedGuaranteeAmountCurrencyType) {
                toast.error('Teminat Bedeli alanını doldurunuz!')
                return false;
            }
            else if (Helpers.isEmpty(antrepoDeclarationDate)) {
                toast.error('Antrepo Beyan Tarihi alanını doldurunuz!')
                return false;
            }
            else if (isLastStep && (_antrepoInVehicles ? _antrepoInVehicles : antrepoInVehicles).filter(x => Helpers.isEmpty(x.antrepoEnteranceDate) && !Helpers.isEmpty(x.vehicleId)).length > 0) {
                toast.error('Araç Bilgileri listesinde tüm Araç alanı dolu kayıtlar için Antrepo Giriş Tarihi alanı dolu olmalıdır!')
                return false;
            }
            else if (!selectedCustomsDirectorate) {
                toast.error('Gümrük Müdürlüğü alanını doldurunuz!');
                return false;
            }
            else if (!selectedReceiverFirm) {
                toast.error('Alıcı Firma alanını doldurunuz!');
                return false;
            }
            else if (!Helpers.isEmpty(antrepoDeclarationDate) && moment(antrepoDeclarationDate, 'YYYY-MM-DDTHH:mm') > moment()) {
                toast.error('Antrepo Beyan Tarihi alanını sistem tarihinden büyük olamaz!')
                return false;
            }
            else if (Helpers.isEmpty(declarationPotQuantity)) {
                toast.error('Beyan Kap Adet alanını doldurunuz!')
                return false;
            }
            else if (Helpers.isEmpty(declarationPotWeight)) {
                toast.error('Beyan Kap Ağırlık (Kg) alanını doldurunuz!')
                return false;
            }
            else if (Helpers.toNumber(declarationPotQuantity) < 0) {
                toast.error('Beyan Kap Adet alanı negatif olamaz!')
                return false;
            }
            else if (Helpers.toNumber(declarationPotWeight) < 0) {
                toast.error('Beyan Kap Ağırlık (Kg) alanı negatif olamaz!')
                return false;
            }
            else {
                var _selectedLockReason = selectedLockReason;

                if (isLastStep) {
                    for (var i = 0; i < antrepoInVehicleProducts.length; i++) {
                        var vehicle = (_antrepoInVehicles ? _antrepoInVehicles : antrepoInVehicles).find(x => x.groupNo == antrepoInVehicleProducts[i].groupNo);

                        if (!vehicle || (Helpers.isEmpty(antrepoInVehicleProducts[i].productLocationId) && !Helpers.isEmpty(vehicle.antrepoEnteranceDate))) {
                            toast.error('Antrepo Giriş Tarihi doldurulmuş tüm araçların ürünleri için Ürün Lokasyonu alanı dolu olmalıdır!');
                            return false;
                        }
                    }
                }

                if (isLastStep && antrepoInVehicleProducts.length > 0 && (_antrepoInVehicles ? _antrepoInVehicles : antrepoInVehicles).filter(x => Helpers.isEmpty(x.antrepoEnteranceDate)).length == 0) {
                    if (Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.potQuantity).map(x => Helpers.toNumber(x.potQuantity))) != Helpers.toNumber(declarationPotQuantity)) {
                        if (!antrepoInLocks.find(x => x.lockReasonKey == "1")) {
                            toast('Beyan Kap Adet giriş Kap Adet alanına eşit değildir, kayıt kilitlenmiştir!', {
                                icon: <i className="fa text-warning fa-exclamation-triangle fs-1 text-primary" />
                            })

                            _isLocked = true;
                            _selectedLockReason = defaultLockReason;
                        }
                    }
                }

                if (isLastStep && antrepoInVehicleProducts.length > 0 && (_antrepoInVehicles ? _antrepoInVehicles : antrepoInVehicles).filter(x => Helpers.isEmpty(x.antrepoEnteranceDate)).length == 0) {
                    if (Helpers.sumOfNumbers(antrepoInVehicleProducts.filter(x => x.grossWeight).map(x => Helpers.toNumber(x.grossWeight))) != Helpers.toNumber(declarationPotWeight)) {
                        if (!antrepoInLocks.find(x => x.lockReasonKey == "1")) {
                            toast('Beyan Kap Ağırlık giriş Kap Ağırlık alanına eşit değildir, kayıt kilitlenmiştir!', {
                                icon: <i className="fa text-warning fa-exclamation-triangle fs-1 text-primary" />
                            })

                            _isLocked = true;
                            _selectedLockReason = defaultLockReason;
                        }
                    }
                }

                dispatch(storeActivityIndicator(true));

                var vehiclesToBeInserted = (_antrepoInVehicles ? _antrepoInVehicles : antrepoInVehicles).map(function (x) {
                    return {
                        antrepoInVehicleId: x.antrepoInVehicleId.startsWith('newrecrd') ? undefined : x.antrepoInVehicleId,
                        containerId: x.containerId,
                        containerNo: x.containerNo,
                        groupNo: x.groupNo,
                        summaryDeclarationDate: x.summaryDeclarationDate,
                        antrepoEnteranceDate: x.antrepoEnteranceDate,
                        summaryDeclarationNo: x.summaryDeclarationNo,
                        summaryDeclarationOrderNo: x.summaryDeclarationOrderNo,
                        summaryDeclarationOrderQuantity: x.summaryDeclarationOrderQuantity,
                        supplierId: x.supplierId,
                        trailerId: x.trailerId,
                        transportDocumentNo: x.transportDocumentNo,
                        truckReportNo: x.truckReportNo,
                        vehicleArriveDate: x.vehicleArriveDate,
                        vehicleId: x.vehicleId,
                        welcomeId: x.welcomeId,
                        evacuationOfficerId: x.evacuationOfficerId,
                        rampId: x.rampId,
                        operatorId: x.operatorId,
                        driverId: x.driverId,
                        willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0,
                        willNotBeInvoicedReason: x.willNotBeInvoicedReason
                    }
                })

                for (var i = 0; i < vehiclesToBeInserted.length; i++) {
                    if (!Helpers.isEmpty(vehiclesToBeInserted[i].welcomeId)) {
                        var response2: GetWelcomeByIdResponse = await WelcomeService.getWelcomeById(vehiclesToBeInserted[i].welcomeId + '');

                        if (!response2.isSuccess) {
                            toast.error(response2.message);
                            dispatch(storeActivityIndicator(false));
                            return false;
                        }

                        if (Helpers.isEmpty(vehiclesToBeInserted[i].vehicleId))
                            vehiclesToBeInserted[i].vehicleId = response2.data.vehicleId;

                        if (Helpers.isEmpty(vehiclesToBeInserted[i].trailerId))
                            vehiclesToBeInserted[i].trailerId = response2.data.trailerId;

                        if (Helpers.isEmpty(vehiclesToBeInserted[i].containerNo))
                            vehiclesToBeInserted[i].containerNo = response2.data.containerNo;

                        if (Helpers.isEmpty(vehiclesToBeInserted[i].vehicleArriveDate))
                            vehiclesToBeInserted[i].vehicleArriveDate = response2.data.vehicleArriveDate;

                        if (Helpers.isEmpty(vehiclesToBeInserted[i].supplierId))
                            vehiclesToBeInserted[i].supplierId = response2.data.supplierId;

                        if (Helpers.isEmpty(vehiclesToBeInserted[i].driverId))
                            vehiclesToBeInserted[i].driverId = response2.data.driverId;
                    }
                }

                var response: AddAntrepoInResponse = await AntrepoInService.addAntrepoIn({
                    antrepoInId: antrepoInId,
                    ledgerNo: ledgerNo ? (ledgerNo == '-' ? undefined : ledgerNo) : undefined,
                    freeStorageRefNo: freeStorageRefNo,
                    saleTypeId: selectedSaleType?.value,
                    antrepoId: selectedAntrepo?.value,
                    antrepoDeclarationNo: antrepoDeclarationNo,
                    goodsAmount: goodsAmount,
                    goodsAmountCurrencyTypeId: selectedGoodsAmountCurrencyType.value,
                    guaranteeTypeId: selectedGuaranteeType?.value,
                    antrepoDeclarationDate: antrepoDeclarationDate,
                    guaranteeAmount: guaranteeAmount,
                    guaranteeAmountCurrencyTypeId: selectedGuaranteeAmountCurrencyType.value,
                    storageEnteranceDate: storageEnteranceDate,
                    customsDirectorateId: selectedCustomsDirectorate?.value,
                    dutyFirmId: selectedDutyFirm?.value,
                    exitCountryId: selectedExitCountry?.value,
                    receiverFirmId: selectedReceiverFirm?.value,
                    representativeId: selectedRepresentative?.value,
                    senderFirmId: selectedSenderFirm?.value,
                    transferAntrepoDeclarationDate: transferAntrepoDeclarationDate,
                    transferAntrepoDeclarationNo: transferAntrepoDeclarationNo,
                    transferFirmId: selectedTransferFirm?.value,
                    transferInvoice: transferInvoice,
                    transferInvoiceFile: transferInvoiceFile,
                    antrepoInVehicles: vehiclesToBeInserted,
                    antrepoInVehicleProducts: antrepoInVehicleProducts.map(function (x) {
                        return {
                            antrepoInVehicleProductId: x.antrepoInVehicleProductId.startsWith('newrecrd') ? undefined : x.antrepoInVehicleProductId,
                            antrepoInVehicleId: x.antrepoInVehicleId.startsWith('newrecrd') ? undefined : x.antrepoInVehicleId,
                            area: x.area,
                            grossWeight: x.grossWeight,
                            groupNo: x.groupNo,
                            gTipId: x.gTipId,
                            netWeight: x.netWeight,
                            potQuantity: x.potQuantity,
                            productTypeId: x.productTypeId,
                            volume: x.volume,
                            productLocationId: x.productLocationId,
                            productKindId: x.productKindId,
                            potTypeId: x.potTypeId,
                            palletCount: x.palletCount,
                        }
                    }),
                    antrepoInVehicleServices: antrepoInVehicleServices.map(function (x) {
                        return {
                            antrepoInVehicleServiceId: x.antrepoInVehicleServiceId.startsWith('newrecrd') ? undefined : x.antrepoInVehicleServiceId,
                            antrepoInVehicleId: x.antrepoInVehicleId.startsWith('newrecrd') ? undefined : x.antrepoInVehicleId,
                            groupNo: x.groupNo,
                            multiplierId: x.multiplierId,
                            quantity: x.quantity,
                            serviceId: x.serviceId,
                            willNotBeInvoiced: x.willNotBeInvoiced ? 1 : 0,
                            willNotBeInvoicedReason: x.willNotBeInvoicedReason
                        }
                    }),
                    fileArchives: fileArchives.map(function (x) {
                        return {
                            description: x.description,
                            entityId: x.entityId,
                            file: x.fileArchiveFile,
                            fileName: x.fileName,
                            fileTypeId: x.fileTypeId,
                            fileArchiveId: x.fileArchiveId
                        }
                    }),
                    antrepoOfferId: antrepoOfferId,
                    declarationPotQuantity: declarationPotQuantity,
                    declarationPotWeight: declarationPotWeight,
                    isLocked: Helpers.isEmpty(_isLocked) ? (isLocked ? 1 : 0) : (_isLocked ? 1 : 0),
                    lockReasonId: (Helpers.isEmpty(_isLocked) ? (isLocked ? 1 : 0) : (_isLocked ? 1 : 0)) ? _selectedLockReason?.value : undefined,
                    unlockReason: (Helpers.isEmpty(_isLocked) ? (isLocked ? 1 : 0) : (_isLocked ? 1 : 0)) ? undefined : unlockReason,
                    transferAntrepoOutId: transferAntrepoOutId,
                    redreseAntrepoInId: redreseAntrepoInId
                });

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return false;
                }

                for (var i = 0; i < vehiclesToBeInserted.length; i++) {
                    if (vehiclesToBeInserted[i].welcomeId) {
                        var response2: GetWelcomeByIdResponse = await WelcomeService.getWelcomeById(vehiclesToBeInserted[i].welcomeId + '');

                        if (!response2.isSuccess) {
                            toast.error(response2.message);
                            dispatch(storeActivityIndicator(false));
                            return false;
                        }

                        if (response2 && response2.data) {
                            var response3: AddWelcomeResponse = await WelcomeService.addWelcome({
                                containerNo: vehiclesToBeInserted[i].containerNo,
                                groupNo: vehiclesToBeInserted[i]?.groupNo?.toString(),
                                supplierId: vehiclesToBeInserted[i].supplierId,
                                trailerId: vehiclesToBeInserted[i].trailerId,
                                vehicleArriveDate: vehiclesToBeInserted[i].vehicleArriveDate,
                                vehicleId: vehiclesToBeInserted[i].vehicleId,
                                welcomeId: vehiclesToBeInserted[i].welcomeId,
                                antrepoIncomingDate: response2.data.antrepoIncomingDate,
                                antrepoOfferId: response2.data.antrepoOfferId,
                                customerId: response2.data.customerId,
                                driverId: response2.data.driverId,
                                isIn: response2.data.isIn ? 1 : 0,
                                isOut: response2.data.isOut ? 1 : 0,
                                refNo: response2.data.refNo,
                                representativeId: response2.data.representativeId,
                                welcomeStatusId: response2.data.welcomeStatusId
                            });

                            if (!response3.isSuccess) {
                                toast.error(response3.message);
                                dispatch(storeActivityIndicator(false));
                                return false;
                            }
                        }
                    }
                }

                setSelectedLockReason(undefined);
                setUnlockReason('');

                var lastSelectedOne = antrepoInVehicles.find(x => x.isSelected)?.groupNo;

                if (!_antrepoInVehicles && (Helpers.isEmpty(_isLocked) || (!Helpers.isEmpty(_isLocked) && _isLocked == true))) {
                    toast.success(response.message);
                    navigate(Helpers.getGoBackUrl());
                }
                else {
                    getData(response.data.antrepoInId, lastSelectedOne, undefined);
                }
                return true;
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
            return false;
        }
    }

    const generateDeclarationNo = (_selectedCustomsDirectorate: CustomSingleSelectModel | undefined) => {
        if (_selectedCustomsDirectorate) {
            setAntrepoDeclarationNo(new Date().getFullYear().toString().substring(2) + _selectedCustomsDirectorate.additionalValue1 + 'AN');
            setDefaultAntrepoDeclarationNo(new Date().getFullYear().toString().substring(2) + _selectedCustomsDirectorate.additionalValue1 + 'AN')
        }
        else {
            setAntrepoDeclarationNo('');
            setDefaultAntrepoDeclarationNo('');
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1]) + (isRedrese ? ' (Redrese) ' : '')}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <PageHeader
                        items={[
                            { text: 'Genel Bilgiler', ref: generalInformationRef },
                            // { text: 'Tarih Bilgileri', ref: dateInformationRef },
                            { text: 'Firma Bilgileri', ref: firmInformationRef },
                            // { text: 'Devir Bilgileri', ref: transferInformationRef },
                            Helpers.isEmpty(transferAntrepoOutId) ? { text: 'Araç Bilgileri', ref: vehicleInformationRef } : undefined,
                            { text: 'Ürün Bilgileri', ref: productInformationRef },
                            { text: 'Ek Hizmetler', ref: serviceInformationRef },
                            antrepoOuts.length > 0 ? { text: 'Bağlı Antrepo Çıkışları', ref: antrepoOutsRef } : undefined,
                            redreseAntrepoIn ? { text: 'Bağlı Redreseli İşlem', ref: redreseAntrepoInRef } : undefined,
                            transferAntrepoOut ? { text: 'Devir Antrepo Çıkışı', ref: transferAntrepoOutsRef } : undefined,
                            { text: 'Geçmiş', ref: antrepoInMessagesRef },
                            { text: 'Dijital Arşiv', ref: fileArchivesRef },
                        ]}
                    />

                    <GeneralInformation
                        antrepoDeclarationDate={antrepoDeclarationDate}
                        antrepoDeclarationNo={antrepoDeclarationNo}
                        freeStorageRefNo={freeStorageRefNo}
                        generalInformationRef={generalInformationRef}
                        goodsAmount={goodsAmount}
                        guaranteeAmount={guaranteeAmount}
                        ledgerNo={ledgerNo}
                        selectedGoodsAmountCurrencyType={selectedGoodsAmountCurrencyType}
                        selectedGuaranteeAmountCurrencyType={selectedGuaranteeAmountCurrencyType}
                        selectedGuaranteeType={selectedGuaranteeType}
                        selectedSaleType={selectedSaleType}
                        setAntrepoDeclarationDate={setAntrepoDeclarationDate}
                        setAntrepoDeclarationNo={setAntrepoDeclarationNo}
                        setFreeStorageRefNo={setFreeStorageRefNo}
                        setGoodsAmount={setGoodsAmount}
                        setGuaranteeAmount={setGuaranteeAmount}
                        setLedgerNo={setLedgerNo}
                        setSelectedGoodsAmountCurrencyType={setSelectedGoodsAmountCurrencyType}
                        setSelectedGuaranteeAmountCurrencyType={setSelectedGuaranteeAmountCurrencyType}
                        setSelectedGuaranteeType={setSelectedGuaranteeType}
                        setSelectedSaleType={setSelectedSaleType}
                        declarationPotQuantity={declarationPotQuantity}
                        declarationPotWeight={declarationPotWeight}
                        setDeclarationPotQuantity={setDeclarationPotQuantity}
                        setDeclarationPotWeight={setDeclarationPotWeight}
                        setSelectedCustomsDirectorate={setSelectedCustomsDirectorate}
                        selectedCustomsDirectorate={selectedCustomsDirectorate}
                        generateDeclarationNo={generateDeclarationNo}
                        defaultAntrepoDeclarationNo={defaultAntrepoDeclarationNo}
                        selectedAntrepo={selectedAntrepo}
                        setSelectedAntrepo={setSelectedAntrepo}
                        isDisabledFromLock={isDisabledFromLock}
                    />

                    {/* <DateInformation
                        dateInformationRef={dateInformationRef}
                        setStorageEnteranceDate={setStorageEnteranceDate}
                        storageEnteranceDate={storageEnteranceDate}
                    /> */}

                    <FirmInformation
                        firmInformationRef={firmInformationRef}
                        selectedDutyFirm={selectedDutyFirm}
                        selectedExitCountry={selectedExitCountry}
                        selectedReceiverFirm={selectedReceiverFirm}
                        selectedRepresentative={selectedRepresentative}
                        selectedSenderFirm={selectedSenderFirm}
                        setSelectedDutyFirm={setSelectedDutyFirm}
                        setSelectedExitCountry={setSelectedExitCountry}
                        setSelectedReceiverFirm={setSelectedReceiverFirm}
                        setSelectedRepresentative={setSelectedRepresentative}
                        setSelectedSenderFirm={setSelectedSenderFirm}
                        isDisabledFromLock={isDisabledFromLock}
                    />

                    {/* <TransferInformation
                        selectedTransferFirm={selectedTransferFirm}
                        setSelectedTransferFirm={setSelectedTransferFirm}
                        setTransferAntrepoDeclarationDate={setTransferAntrepoDeclarationDate}
                        setTransferAntrepoDeclarationNo={setTransferAntrepoDeclarationNo}
                        setTransferInvoiceFile={setTransferInvoiceFile}
                        transferAntrepoDeclarationDate={transferAntrepoDeclarationDate}
                        transferAntrepoDeclarationNo={transferAntrepoDeclarationNo}
                        transferInformationRef={transferInformationRef}
                        transferInvoice={transferInvoice}
                    /> */}

                    {
                        Helpers.isEmpty(transferAntrepoOutId) && (
                            <VehicleInformation
                                antrepoInVehicles={antrepoInVehicles}
                                setAntrepoInVehicles={setAntrepoInVehicles}
                                vehicleInformationRef={vehicleInformationRef}
                                antrepoInVehicleProducts={antrepoInVehicleProducts}
                                setAntrepoInVehicleProducts={setAntrepoInVehicleProducts}
                                antrepoInVehicleServices={antrepoInVehicleServices}
                                setAntrepoInVehicleServices={setAntrepoInVehicleServices}
                                welcomeList={welcomeList}
                                antrepoInId={antrepoInId}
                                setWelcomeList={setWelcomeList}
                                ledgerNo={ledgerNo}
                                selectedSenderFirm={selectedSenderFirm}
                                saveAntrepoIn={saveAntrepoIn}
                                selectedReceiverFirm={selectedReceiverFirm}
                                selectedAntrepo={selectedAntrepo}
                                isDisabledFromLock={isDisabledFromLock}
                            />
                        )
                    }


                    <ProductInformation
                        antrepoInVehicleProducts={antrepoInVehicleProducts}
                        antrepoInVehicles={antrepoInVehicles}
                        defaultProductType={defaultProductType}
                        productInformationRef={productInformationRef}
                        selectedProductType={selectedProductType}
                        setAntrepoInVehicleProducts={setAntrepoInVehicleProducts}
                        setSelectedProductType={setSelectedProductType}
                        antrepoInId={antrepoInId}
                        ledgerNo={ledgerNo}
                        selectedAntrepo={selectedAntrepo}
                        isDisabledFromLock={isDisabledFromLock}
                    />

                    <ServicesInformation
                        antrepoInVehicleServices={antrepoInVehicleServices}
                        antrepoInVehicles={antrepoInVehicles}
                        serviceInformationRef={serviceInformationRef}
                        setAntrepoInVehicleServices={setAntrepoInVehicleServices}
                        antrepoInId={antrepoInId}
                        ledgerNo={ledgerNo}
                        isDisabledFromLock={isDisabledFromLock}
                    />

                    {
                        antrepoOuts.length > 0 && (
                            <AntrepoOuts
                                antrepoOuts={antrepoOuts}
                                antrepoOutsRef={antrepoOutsRef}
                            />
                        )
                    }

                    {
                        transferAntrepoOut && (
                            <TransferAntrepoOuts
                                transferAntrepoOuts={[transferAntrepoOut]}
                                transferAntrepoOutsRef={transferAntrepoOutsRef}
                            />
                        )
                    }

                    {
                        redreseAntrepoIn && (
                            <RedreseAntrepoIn
                                redreseAntrepoIn={[redreseAntrepoIn]}
                                redreseAntrepoInRef={redreseAntrepoInRef}
                            />
                        )
                    }

                    <MessageHistory
                        antrepoInMessages={antrepoInMessages}
                        antrepoInMessagesRef={antrepoInMessagesRef}
                    />

                    <FileArchives
                        fileArchives={fileArchives}
                        fileArchivesRef={fileArchivesRef}
                        setFileArchives={setFileArchives}
                        isDisabledFromLock={isDisabledFromLock}
                    />

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="center">
                                <Box justifyContent='center'>
                                    {
                                        !isLocked && (
                                            <Box flexDirection="row">
                                                <Box width="400px" justifyContent="center">
                                                    <CustomSingleSelect
                                                        selectedValue={selectedLockReason}
                                                        onChange={setSelectedLockReason}
                                                        insertable={{
                                                            onSubmit: { code: 'ANTREPO_IN_LOCK_REASON' }
                                                        }}
                                                        onMenuOpen={() => ConstantService.getConstantList('ANTREPO_IN_LOCK_REASON')}
                                                        labelName='value'
                                                        valueName='constantId'
                                                        additionalValue1Name="additionalValue1"
                                                        placeholder="Kilit Nedeni Seçiniz"
                                                    />
                                                </Box>
                                                <Box ml="15px" justifyContent="center">
                                                    <button className="btn btn-danger btn-sm" onClick={lockRecord}><i className="fs-6 fa fa-lock"></i>Kilitle</button>
                                                </Box>
                                            </Box>
                                        )
                                    }

                                    {
                                        (isLocked && auth.user.user?.data.roles.find(x => x == "Giriş Beyan Onay") && !Helpers.isEmpty(antrepoInId)) && (
                                            <Box flexDirection="row">
                                                <Box width="400px" justifyContent="center">
                                                    <CustomTextInput placeholder="Kilit Açma Açıklaması" value={unlockReason} setValue={setUnlockReason} />
                                                </Box>
                                                <Box ml="15px" justifyContent="center">
                                                    <button className="btn btn-success btn-sm" onClick={unlockRecord}><i className="fs-6 fa fa-unlock"></i>Kilidi Aç</button>
                                                </Box>
                                            </Box>
                                        )
                                    }
                                </Box>

                                <Box flexGrow={1}>&nbsp;</Box>

                                <Box justifyContent='center'>
                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>

                                {
                                    !isDisabledFromLock && (
                                        <Box ml="15px" justifyContent='center'>
                                            <button className="btn btn-primary btn-sm" onClick={() => saveAntrepoIn(undefined, undefined, true)}>Kaydet</button>
                                        </Box>
                                    )
                                }
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box >
        </React.Fragment >
    )
}

export default AntrepoInAdd;